module.exports = __webpack_public_path__ + "img/48740351011523.36cd74bf.png";